import { InputHTMLAttributes } from 'react';
import { classNames } from '@/utils/classNames';
import styles from './Checkbox.module.css';

type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label?: string;
};

export const Checkbox = ({ label, className, id, style, ...rest }: CheckboxProps) => (
  <label
    style={style}
    className={classNames(styles.root, rest.disabled && styles.disabled, className)}
  >
    <input type="checkbox" className={styles.input} id={id} {...rest} />
    <span className={styles.visual} aria-hidden>
      <svg className={styles.checkmark} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 6L5 9L10 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
    {label && <span className={styles.label}>{label}</span>}
  </label>
);
